import { FunctionComponent } from 'react';
import { Redirect, useParams } from 'react-router-dom';

type FC = FunctionComponent;

const TokenRouteHandler: FC = () => {
  const { token } = useParams<{ token?: string }>();
  const searchLocation = window.location.search.replace('?', '');
  const search = searchLocation !== '' && searchLocation ? `&${searchLocation}` : '';

  if (window.location.hostname.includes('request')) {
    return <Redirect to={{ pathname: '/', search: `?Token=${token || ''}${search}` }} />;
  }

  return <Redirect to={{ pathname: '/', search: `?IframeKey=${token || ''}${search}` }} />;
};

export default TokenRouteHandler;
